import { PopoverPlacement } from "@idui/react-popover";
import { IconButton } from "@mui/material";
import { FC } from "react";

import { PIC } from "@ryde/assets";

import { FramerTooltip } from "../../../tooltips";

interface IButtonAddEntity {
  tooltip: string;
  onClick: () => void;
}

export const ButtonAddEntity: FC<IButtonAddEntity> = ({ tooltip, onClick }) => {
  return (
    <FramerTooltip content={tooltip} placement={PopoverPlacement.top}>
      {/* Prevent "A disabled element does not fire events." MUI error*/}
      <span>
        <IconButton onClick={onClick} color="primary">
          <PIC.PlusCircleSvg width={20} height={20} />
        </IconButton>
      </span>
    </FramerTooltip>
  );
};
